/**
 * Утилита для проверки типов деталей с поддержкой обратной совместимости
 * Проверяет как новые русские названия, так и старые английские для совместимости
 */

export enum PartType {
    BRACKET = "bracket",
    AMP = "amp",
    EDGE = "edge",
    PUNCH_PANEL = "punchPanel",
}

/**
 * Проверяет, является ли деталь кронштейном
 */
export const isBracket = (partType?: string[] | string | false): boolean => {
    if (!partType) return false;
    const types = Array.isArray(partType) ? partType : [partType];
    return types.some((type) => type.includes("Кронштейн") || type.includes("bracket"));
};

/**
 * Проверяет, является ли деталь усилителем
 */
export const isAmplifier = (partType?: string[] | string | false): boolean => {
    if (!partType) return false;
    const types = Array.isArray(partType) ? partType : [partType];
    return types.some((type) => type.includes("Усилитель") || type.includes("amp"));
};

/**
 * Проверяет, является ли деталь ребром жесткости
 */
export const isEdge = (partType?: string[] | string | false): boolean => {
    if (!partType) return false;
    const types = Array.isArray(partType) ? partType : [partType];
    return types.some((type) => type.includes("Ребро жесткости") || type.includes("edge"));
};

/**
 * Проверяет, является ли деталь перфопанелью
 */
export const isPunchPanel = (partType?: string[] | string | false): boolean => {
    if (!partType) return false;
    const types = Array.isArray(partType) ? partType : [partType];
    return types.some((type) => type.includes("Перфопанель") || type.includes("punchPanel"));
};

/**
 * Проверяет, является ли деталь соединителем
 */
export const isConnector = (partType?: string[] | string | false): boolean => {
    if (!partType) return false;
    const types = Array.isArray(partType) ? partType : [partType];
    return types.some((type) => type.includes("Соединитель") || type.includes("connector"));
};

/**
 * Проверяет, является ли деталь колесом
 */
export const isWheel = (partType?: string[] | string | false): boolean => {
    if (!partType) return false;
    const types = Array.isArray(partType) ? partType : [partType];
    return types.some((type) => type.includes("Колесо") || type.includes("wheel"));
};

/**
 * Проверяет, является ли деталь подвесом
 */
export const isSuspension = (partType?: string[] | string | false): boolean => {
    if (!partType) return false;
    const types = Array.isArray(partType) ? partType : [partType];
    return types.some((type) => type.includes("Подвес") || type.includes("suspension"));
};

/**
 * Проверяет, является ли деталь штангой
 */
export const isRod = (partType?: string[] | string | false): boolean => {
    if (!partType) return false;
    const types = Array.isArray(partType) ? partType : [partType];
    return types.some((type) => type.includes("Штанга") || type.includes("rod"));
};

/**
 * Проверяет, НЕ является ли деталь служебной (кронштейн, усилитель, ребро жесткости)
 * Используется для фильтрации основных деталей
 */
export const isNotServicePart = (partType?: string[] | string | false): boolean => {
    return !isBracket(partType) && !isAmplifier(partType) && !isEdge(partType) && !isRod(partType);
};
